const cateringData = {
  intro: {
    title: "Let Star Cater Your Next Event",
    subtitle:
      "Holidays • Office Events • Life Cycle Events • Sporting Events • Condolences",
    notes: "10 Person Minimum",
  },

  trays: [
    {
      id: "salad-tray",
      name: "Salad Tray",
      price: "19.99",
      priceUnit: "per person",
      image: "/images/catering/salad-tray.jpg", // Path to premium catering tray photo
      items: [
        "Star's famous tuna salad",
        "Chicken salad",
        "Egg salad",
        "Farmers salad",
        "Sliced Tomato",
        "Sliced Cucumber",
        "Sliced Onion",
        "Assorted Cheeses",
      ],
      notes: "Choice of: Bagels, Rolls, Bread",
      addons: [
        {
          name: "Lox* & Cream Cheese",
          price: "24.99",
          priceUnit: "per person",
          replacePrice: true,
        },
      ],
    },
    {
      id: "meat-tray",
      name: "Meat Tray",
      price: "18.99",
      priceUnit: "per person",
      image: "/images/catering/meat-tray.jpg", // Path to premium catering tray photo
      items: [
        "Lean corned beef",
        "Turkey breast",
        "Turkey pastrami",
        "Soft salami",
        "Rare roast beef*",
        "Homemade potato salad",
        "Homemade coleslaw",
        "Old & new dill pickles",
      ],
      description:
        "Garnished with: Dill tomatoes • Red & yellow bell peppers • Olives (green & black)",
      notes: "Rye bread • Russian dressing • Mustard • Mayo",
      addons: [
        {
          name: "Swiss & Munster Cheese",
          price: "",
          priceUnit: "",
          description: "(additional charge)",
        },
      ],
    },
    {
      id: "dairy-tray",
      name: "Dairy Tray",
      price: "29.99",
      priceUnit: "per person",
      image: "/images/catering/dairy-tray.jpg", // Path to premium catering tray photo
      items: [
        "Nova lox*",
        "Smoked sable",
        "Smoked whitefish",
        "Star's famous tuna salad",
        "Creamed herring",
        "Cream cheese",
        "Cottage cheese",
        "Sliced hard boiled eggs",
        "Muenster cheese",
        "Swiss cheese",
        "American cheese",
        "Sliced Tomato",
        "Sliced Cucumber",
        "Sliced Onion",
        "Sliced Lemon",
        "Greek olives",
      ],
      notes: "Choice of: Bagels & Rolls",
    },
    {
      id: "breakfast-tray",
      name: "Breakfast Tray",
      price: "10.99",
      priceUnit: "per person",
      image: "/images/catering/breakfast-tray.jpg", // Path to premium catering tray photo
      items: [
        "Assorted bagels",
        "Assorted Danish",
        "Fruit salad",
        "Cream Cheese",
        "Butter",
        "Orange Juice",
      ],
    },
    {
      id: "sandwich-tray",
      name: "Sandwich Tray",
      price: "",
      priceDescription: "Dependent on Selection",
      image: "/images/catering/sandwich-tray.jpg", // Path to premium catering tray photo
      description: "Choice of Sandwiches • New & Old Dill Pickles",
    },
    {
      id: "dessert-tray",
      name: "Dessert Tray",
      price: "",
      priceDescription: "Call for Pricing",
      image: "/images/catering/dessert-tray.jpg", // Path to premium catering tray photo
      items: [
        "Freshly-baked chocolate chip cookies",
        "Assorted chocolate-iced cake slices",
        "Nut-topped cinnamon swirled cake slices",
      ],
      description: "A delightful assortment of fresh bakery sweets to complete your meal.",
    },
    {
      id: "veggie-tray",
      name: "Veggie Tray",
      price: "",
      priceDescription: "Call for Pricing",
      image: "/images/catering/veggie-tray.jpg", // Path to premium catering tray photo
      items: [
        "Fresh broccoli & cauliflower florets",
        "Crisp celery & carrot sticks",
        "Sliced cucumbers & cherry tomatoes",
        "Assorted bell peppers & banana peppers",
        "Whole white button mushrooms",
        "Symmetrically arranged scallions & olives",
      ],
      description: "Served with a generous container of our homemade signature dill dip.",
    },
  ],

  boxedLunches: {
    id: "boxed-lunches",
    name: "Boxed Lunches",
    price: "24.00",
    priceUnit: "each",
    image: "/images/catering/boxed-lunch.jpg", // Path to premium catering tray photo
    description:
      "Choice of regular sandwich • Side of coleslaw or potato salad • Small chips • Cookie • Old or new dill pickle • Pop or water",
    addons: [
      {
        name: "Specialty Sandwich",
        price: "26.00",
        priceUnit: "each",
        replacePrice: true,
      },
    ],
  },

  saladBowls: {
    id: "salad-bowls",
    name: "Salad Bowls",
    minPeople: 6,
    note: "6 person MINIMUM",
  },
  
  saladBowlItems: [
    {
      id: "toss-salad",
      name: "Toss Salad",
      price: "5.25",
      priceUnit: "per person",
      image: "/images/catering/toss-salad.jpg", // Path to premium catering tray photo
      description: "Fresh mixed greens with tomatoes, cucumbers, and your choice of dressing"
    },
    {
      id: "greek-salad",
      name: "Greek Salad Bowl",
      price: "6.25",
      priceUnit: "per person",
      image: "/images/catering/greek-salad.jpg", // Path to premium catering tray photo
      description: "Mixed greens with feta cheese, kalamata olives, tomatoes, cucumbers, and Greek dressing"
    },
    {
      id: "fruit-salad",
      name: "Fruit Salad Bowl",
      price: "7.99",
      priceUnit: "per pound",
      image: "/images/catering/fruit-salad.jpg", // Path to premium catering tray photo
      description: "Fresh seasonal fruits including melons, berries, and grapes"
    }
  ],

  cateringFootnotes: [
    "* Items marked with an asterisk may contain undercooked ingredients. Consuming raw or undercooked meats, poultry, seafood, shellfish or eggs may increase your risk of foodborne illness."
    // The other two notes have been moved directly into the info cards in CateringPage.js
  ],
};

export default cateringData;
